import React from "react"
import {Link} from "react-router-dom";
import { useState, useEffect } from "react"

import UseWindowSize from "./UseWindowSize"

import FadeInSection from "./FadeInSection"
import DateModalCalc from "./DateModalCalc"

import IconBarSocial from "./IconBarSocial"
import Paradise from "./Paradise"

function GridVerticaFreeFormEditors(props){

    const size = UseWindowSize()

    const [first, setFirst] = useState([])
    const [others, setOthers] = useState([])

    useEffect(() => {
      if(props.articles[0]){
        setFirst([props.articles[0]])
        const [, ...rest] = props.articles
        setOthers(rest)
      }
    }, [props.articles]);

      return (
        <article className="post">
        {first.length != 0 && first.map(article => (
          <FadeInSection>
          <div id="test">
            <h1 style={{textAlign:"center"}}>{article.title}</h1>
            {article.paras.map(para => (
            <div>
            <p>{para}</p>
            </div>
            ))}
            <Link to={article.author}>
            <h1 style={{textAlign:"right"}}>{article.author}</h1>
            </Link>
            <DateModalCalc article={article}/>
          </div>
          {props.newsletter &&
          <div>
          <Paradise art={true} />
          <IconBarSocial />
          </div>
          }
          </FadeInSection>
        ))}
        {others.length != 0 && others.map(article => (
          <FadeInSection>
          <div>
            <h1 style={{textAlign:"center"}}>{article.title}</h1>
            {article.paras.map(para => (
            <div>
            <p>{para}</p>
            </div>
            ))}
            <Link to={article.author}>
            <h1 style={{textAlign:"right"}}>{article.author}</h1>
            </Link>
            <DateModalCalc article={article}/>
          </div>
          </FadeInSection>
        ))}
        </article>
      )

    }

export default GridVerticaFreeFormEditors
